import { createAction, props } from '@ngrx/store';

export const cambiarEmpresa = createAction(
  '[Emps] Cambiando Dato de Empresa',
  props<{ emp: object }>()
);

export type accionesValidas = ReturnType<typeof cambiarEmpresa>;
